import { Link } from 'react-router-dom'

const types = [
  {
    href: '/inscription/entreprise',
    icon: '🏢',
    label: 'Entreprise',
    description: 'Publiez des missions événementielles et formations, trouvez des prestataires qualifiés.',
    color: 'accent',
  },
  {
    href: '/inscription/centre-de-formation',
    icon: '🎓',
    label: 'Centre de formation',
    description: 'Gérez vos sessions de formation, votre catalogue et votre certification Qualiopi.',
    color: 'success',
  },
  {
    href: '/inscription/prestataire',
    icon: '👤',
    label: 'Prestataire',
    description: 'Proposez vos services, acceptez des missions et développez votre activité.',
    color: 'accent',
  },
]

export default function InscriptionChoixPage() {
  return (
    <>
      <div className="flex justify-center mb-8">
        <div className="flex items-center gap-2.5">
          <div className="w-10 h-10 rounded-xl bg-accent/20 border border-accent/30 flex items-center justify-center">
            <span className="text-accent font-bold text-lg">V</span>
          </div>
          <span className="font-semibold text-text-primary text-xl tracking-tight">Velink</span>
        </div>
      </div>

      <div className="glass-card p-8">
        <div className="mb-7 text-center">
          <h1 className="text-2xl font-bold text-text-primary">Créer un compte</h1>
          <p className="text-text-secondary text-sm mt-2">Quel type de compte souhaitez-vous créer ?</p>
        </div>

        <div className="space-y-3">
          {types.map((t) => (
            <Link
              key={t.href}
              to={t.href}
              className="flex items-center gap-4 p-4 rounded-xl border border-white/[0.10] bg-white/[0.04] hover:bg-white/[0.08] hover:border-white/[0.18] transition-all group"
            >
              <div className="w-12 h-12 rounded-xl bg-accent/10 border border-accent/20 flex items-center justify-center text-2xl flex-shrink-0 group-hover:scale-105 transition-transform">
                {t.icon}
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-text-primary font-semibold text-sm">{t.label}</p>
                <p className="text-text-muted text-xs mt-0.5 leading-relaxed">{t.description}</p>
              </div>
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-text-muted group-hover:text-text-secondary flex-shrink-0 transition-colors">
                <path d="m9 18 6-6-6-6"/>
              </svg>
            </Link>
          ))}
        </div>

        <p className="text-center text-text-muted text-sm mt-6">
          Déjà inscrit ?{' '}
          <Link to="/connexion" className="text-accent hover:text-accent-hover transition-colors">
            Se connecter
          </Link>
        </p>
      </div>
    </>
  )
}
